export const STARTING_ENERGY = 100;

export const ENERGY_PER = 50;

export const SURVIVE_MAX_LEVEL = 25;

export const surviveAlpha = [
  {foe: 'A', health: 50, powers: {drain: 4}},
  {foe: 'B', health: 50, powers: {drain: 4}},
  {foe: 'C', health: 60, powers: {drain: 4}},
  {foe: 'D', health: 60, powers: {drain: 4}},

  {foe: 'E', health: 70, powers: {drain: 5}},
  {foe: 'F', health: 70, powers: {drain: 5}},
  {foe: 'G', health: 80, powers: {drain: 5}},
  {foe: 'H', health: 80, powers: {drain: 5}},

  {foe: 'I', health: 90, powers: {drain: 6}},
  {foe: 'J', health: 90, powers: {drain: 6}},
  {foe: 'K', health: 100, powers: {drain: 6}},
  {foe: 'L', health: 100, powers: {drain: 6}},
  {foe: 'M', health: 110, powers: {drain: 6}},
  {foe: 'N', health: 110, powers: {drain: 6}},

  {foe: 'O', health: 120, powers: {drain: 7}},
  {foe: 'P', health: 120, powers: {drain: 7}},
  {foe: 'Q', health: 140, powers: {drain: 7}},
  {foe: 'R', health: 140, powers: {drain: 7}},
  {foe: 'S', health: 160, powers: {drain: 7}},
  {foe: 'T', health: 160, powers: {drain: 7}},

  {foe: 'U', health: 180, powers: {drain: 8}},
  {foe: 'V', health: 190, powers: {drain: 8}},
  {foe: 'W', health: 200, powers: {drain: 8}},
  {foe: 'X', health: 210, powers: {drain: 8}},
  {foe: 'Y', health: 220, powers: {drain: 8}},
  {foe: 'Z', health: 250, powers: {drain: 10}},
];
